import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getGameDetails, getProfessionalLeagueRanks, getTeamNhlSchedule } from '../redux'

import Loader from '../components/Loader'
import ViewBreakdown from '../components/modal/ViewBreakdown'

import GoalieImage from '../assets/goalie-player.jpeg'
import HockeyImage from '../assets/hockey-player.jpeg'

import Carousel from 'react-multi-carousel'

import { TiChevronRight, TiChevronLeft } from 'react-icons/ti'
import MainHeader from '../components/MainHeader'

const LiveScoring = () => {
  const SETTING = useSelector((state) => state.user.setting)
  const USER = useSelector((state) => state.user)
  const [isLoading, setIsloading] = useState('all')
  const [topTeamData, setTopTeamData] = useState(null)
  const [gameDetailsData, setGameDetailsData] = useState(null)
  const [nhlSchedule, setNhlSchedule] = useState(null)
  const [singleTeam, setSingleTeam] = useState(null)

  const { state } = useLocation()

  useEffect(() => {
    getAllData()
  }, [SETTING?.date])

  const getAllData = async () => {
    setIsloading('all')
    const topTeamRes = await getTopTeams()
    const userTeam = USER?.userDetails?.team?._id
    const teamId = state?.teamId
      ? state?.teamId
      : userTeam
      ? userTeam
      : topTeamRes?.teamRanks?.[0]?.teamId
    setSingleTeam(topTeamRes?.teamRanks?.find((t) => t?.teamId === teamId))
    await getNhlSchedule()
    await getTeamDetails(teamId)
    setIsloading('')
  }

  const getNhlSchedule = async () => {
    const res = await getTeamNhlSchedule({ date: SETTING.date })
    setNhlSchedule(res)
    return res
  }
  const getTeamDetails = async (teamId) => {
    const res = await getGameDetails({ teamId, date: SETTING.date })
    setGameDetailsData(res)
    return res
  }
  const getTopTeams = async () => {
    let res = await getProfessionalLeagueRanks(SETTING?.date)
    setTopTeamData(res)
    return res
  }
  const handleTeamChange = async (teamId) => {
    window.scrollTo(0, 300)
    setIsloading('details')
    setSingleTeam(topTeamData?.teamRanks?.find((t) => t?.teamId === teamId))
    await getTeamDetails(teamId)
    setIsloading('')
  }

  return (
    <div className='live_scoring_container'>
      <MainHeader />

      {isLoading === 'all' ? (
        <Loader />
      ) : (
        <div className='lsc_body'>
          <div className='lsc_body_left'>
            <TopTeamsCard data={topTeamData} onClick={handleTeamChange} />
          </div>
          <div className='lsc_body_right'>
            {isLoading === 'details' ? (
              <Loader />
            ) : (
              <div className='wrapper'>
                <CarouselComponent data={nhlSchedule} />
                <p>
                  LIVE<b>SCORING</b>
                </p>
                <div className='ls_details_box'>
                  <div className='lsdb_wrapper'>
                    <div className='team_header'>
                      <h2>{singleTeam?.teamData?.[0]?.name}</h2>
                      <div className='t_header_details'>
                        <div
                          className='t_logo'
                          style={{ backgroundImage: `url(${singleTeam?.teamData?.[0]?.logo})` }}
                        ></div>
                        <div className='t_total'>
                          <p>TOTAL</p>
                          <h2>{singleTeam?.teamScore?.pf?.toFixed(2)}</h2>
                        </div>
                        <div className='t_live'>
                          <p>LIVE</p>
                          <h2>{singleTeam?.teamScore?.score?.toFixed(2)}</h2>
                        </div>
                      </div>
                    </div>
                    <PlayerDetails
                      lpgHeading={'1st LINE'}
                      scoreField
                      data={gameDetailsData?.line1Players}
                      percent={100}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'1st PAIR'}
                      data={gameDetailsData?.pair1Players}
                      percent={100}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'GOALIE'}
                      data={gameDetailsData?.goaliePlayers}
                      percent={100}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'2nd LINE'}
                      data={gameDetailsData?.line2Players}
                      percent={90}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'2nd PAIR'}
                      data={gameDetailsData?.pair2Players}
                      percent={90}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'3rd LINE'}
                      data={gameDetailsData?.line3Players}
                      percent={80}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'3rd PAIR'}
                      data={gameDetailsData?.pair3Players}
                      percent={80}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={'4th LINE'}
                      data={gameDetailsData?.line4Players}
                      percent={70}
                      nhlScheduleData={nhlSchedule}
                    />
                    <PlayerDetails
                      lpgHeading={<span style={{ fontSize: '14px' }}>EXTRA DEF</span>}
                      data={gameDetailsData?.extraPlayers}
                      percent={80}
                      nhlScheduleData={nhlSchedule}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

const CarouselComponent = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 5,
    },
  }

  let carousel

  const handleBeforeChange = (currentSlide) => {
    setCurrentSlide(currentSlide)
  }

  const handleNext = () => {
    // if (carousel && currentSlide < data.length - 1) {
    //   carousel.next()
    // }
    carousel.next()
  }

  // const handlePrev = () => {
  //   if (carousel && currentSlide > 0) {
  //     carousel.previous()
  //   }
  // }

  const getSchedule = (status, obj) => {
    let value = null
    if (status === 'Final') {
      value = 'F'
    } else if (status === 'Scheduled') {
      value = 'S'
    } else {
      const minutes = obj?.TimeRemainingMinutes > 0 ? obj?.TimeRemainingMinutes : '00'
      const seconds = obj?.TimeRemainingSeconds > 0 ? obj?.TimeRemainingSeconds : '00'
      value = `${minutes} : ${seconds} ${status}`
    }
    return value
  }

  return (
    <div className='carousel_box'>
      <div className='carousel'>
        <Carousel
          responsive={responsive}
          arrows={false}
          ref={(el) => (carousel = el)}
          beforeChange={handleBeforeChange}
          infinite={true}
        >
          {data?.map((v, i) => {
            const activeClass = v?.Status === 'InProgress' ? 'active' : ''
            return (
              <div key={i} className='carousel_card'>
                <div className='row'>
                  <p className={`${activeClass}`}>{v?.HomeTeam}</p>
                  <p className={`${activeClass}`}>
                    {v?.HomeTeamScore > 0 ? v?.HomeTeamScore : '-'}
                  </p>
                </div>
                <div className='row'>
                  <p className={`${activeClass}`}>{v?.AwayTeam}</p>
                  <p className={`${activeClass}`}>
                    {v?.AwayTeamScore > 0 ? v?.AwayTeamScore : '-'}
                  </p>
                </div>
                <div className='row'>
                  <p className={`${activeClass}`}>{getSchedule(v?.Status, v)}</p>
                </div>
              </div>
            )
          })}
        </Carousel>
      </div>

      <div className='carousel_arrow'>
        {/* <div
          className={`arrow`}
          onClick={handlePrev}
          style={{ display: currentSlide === 0 ? 'none' : 'flex' }}
        >
          <TiChevronLeft color={'#fff'} size={50} />
        </div> */}
        <div
          className={`arrow`}
          // style={{
          //   display: currentSlide === data.length - 1 ? 'none' : 'flex',
          // }}
          onClick={handleNext}
        >
          <TiChevronRight color={'#fff'} size={50} />
        </div>
      </div>
    </div>
  )
}

const PlayerDetails = ({ lpgHeading, scoreField = false, data, percent, nhlScheduleData }) => {
  const getPostionAndColor = (position) => {
    const obj = {
      RW: {
        color: 'winger_color',
        position: 'WINGER',
      },
      C: {
        color: 'center_color',
        position: 'CENTER',
      },
      LW: {
        color: 'winger_color',
        position: 'WINGER',
      },
      G: {
        color: 'goalie_color',
        position: 'GOALIE',
      },
      D: {
        color: 'defender_color',
        position: 'DEFENDER',
      },
    }
    return obj[position]
  }
  const getTotalScore = () => {
    const total = data?.reduce((acc, obj) => acc + obj?.player?.playerScore, 0)
    return ((Number(total) * Number(percent)) / 100)?.toFixed(2)
  }

  const scheduleScore = (team) => {
    const isAwayTeam = nhlScheduleData?.find((v) => v?.AwayTeam === team)
    const isHomeTeam = nhlScheduleData?.find((v) => v?.HomeTeam === team)
    let points = null

    if (team) {
      if (isAwayTeam) {
        points = isAwayTeam.AwayTeamScore > 0 ? isAwayTeam.AwayTeamScore : '-'
      } else if (isHomeTeam) {
        points = isHomeTeam.HomeTeamScore > 0 ? isHomeTeam.HomeTeamScore : '-'
      } else {
        points = '-'
      }
    } else {
      points = '-'
    }

    return points
  }

  return (
    <div className='player_details_container'>
      <div className='pd_header'>
        <div className='pdh_left'>
          <div>
            <p>{lpgHeading}</p>
          </div>
          <p> {getTotalScore()}</p>
        </div>
        {scoreField && (
          <div className='pdh_right'>
            <p>
              PLAYER <b>SCORE</b>
            </p>
            <p>
              LINE <b>SCORE</b>
            </p>
          </div>
        )}
      </div>
      {data?.length > 0 ? (
        data?.map((v, i) => {
          const Image = v?.player?.player_id?.HostedHeadshotNoBackgroundUrl
          const Name = v?.player?.player_id?.Name
          const Position = v?.player?.player_id?.Position
          const Team = v?.player?.player_id?.Team
          const Opponent = v?.player?.player_id?.Opponent
          const PlayerScore = v?.player?.playerScore?.toFixed(2)

          return (
            <div key={Name + i} className='pd_card_box'>
              <div className='pd_card'>
                <div className='content_left'>
                  <div className='content_left_small' />
                  <div className='p_img_box'>
                    <img
                      src={Image ? Image : Position === 'G' ? GoalieImage : HockeyImage}
                      alt={'Player'}
                    />
                  </div>
                  <div className='p_content'>
                    <div className='p_content_top'>
                      <p className='p_name'>{Name}</p>
                      <p className='p_team'>{Team && `-${Team}`}</p>
                    </div>
                    <div className='p_content_bottom'>
                      <p className={`p_position ${getPostionAndColor(Position)?.color}`}>
                        {getPostionAndColor(Position)?.position}
                      </p>
                      <p className='p_team_opp'>
                        {Team} {scheduleScore(Team)} {Opponent && '@'} {Opponent}{' '}
                        {Opponent && scheduleScore(Opponent)}
                      </p>
                    </div>
                  </div>
                  <div className='bd_box'>
                    <ViewBreakdown data={v?.player} btnClass={'btn'} />
                  </div>
                </div>
                <div className='content_right'>
                  <p>{PlayerScore}</p>
                  <p>{((Number(PlayerScore) * Number(percent)) / 100)?.toFixed(2)}</p>
                </div>
              </div>
            </div>
          )
        })
      ) : (
        <div className='empty_data'>
          <p>Empty</p>
        </div>
      )}
    </div>
  )
}

const TopTeamsCard = ({ data, onClick }) => {
  return (
    <div className='ttc_box'>
      <p className='tt_heading'>
        TOP<b>TEAMS</b>
      </p>
      <div className='ttc_body'>
        {data?.teamRanks
          ?.slice()
          ?.sort((a, b) => b.teamScore?.pf - a.teamScore?.pf)
          .map((v, i) => {
            return (
              <div key={i} className='tt_card'>
                <div className='index_box'>
                  <p>{i + 1}</p>
                </div>
                <div className='content' onClick={() => onClick(v?.teamId)}>
                  <div
                    className='image_box'
                    style={{ backgroundImage: `url(${v?.teamData[0]?.logo})` }}
                  ></div>
                  <div className='total_score'>
                    <p>TOTAL</p>
                    <p>{v?.teamScore?.pf?.toFixed(2)}</p>
                  </div>
                  <div className='live_score'>
                    <p>LIVE</p>
                    <p>{v?.teamScore?.score?.toFixed(2)}</p>
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default LiveScoring
